import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, CircularProgress, Paper } from '@mui/material';
import { authService } from '../services/authService';

/**
 * OAuth Callback Page
 * Handles the OAuth redirect from Reddit/Facebook/YouTube
 * Backend processes the callback and sets session cookie
 */
const CallbackPage = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Completing authentication...');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Wait a moment for backend to process callback
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Fetch user info to verify authentication
        const result = await authService.handleOAuthCallback();
        
        if (result.success) {
          setStatus('success');
          setMessage('Authentication successful! Redirecting...');
          
          // Redirect to dashboard after short delay
          setTimeout(() => {
            navigate('/dashboard');
          }, 1500);
        } else {
          setStatus('error');
          setMessage('Authentication failed. Please try again.');
          
          // Redirect to login after delay
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        }
      } catch (error) {
        console.error('Callback error:', error);
        setStatus('error');
        setMessage('Authentication failed. Please try again.');
        
        // Redirect to login after delay
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 8 } }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          mt: 2,
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
          boxShadow: '0 8px 32px rgba(42, 49, 66, 0.08)',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        {status === 'processing' && (
          <>
            <CircularProgress size={60} sx={{ mb: 3 }} />
            <Typography variant="h5" gutterBottom>
              {message}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Please wait...
            </Typography>
          </>
        )}
        
        {status === 'success' && (
          <>
            <Typography variant="h4" color="success.main" gutterBottom>
              ✓ {message}
            </Typography>
          </>
        )}
        
        {status === 'error' && (
          <>
            <Typography variant="h4" color="error.main" gutterBottom>
              ✗ {message}
            </Typography>
          </>
        )}
        </Box>
      </Paper>
    </Container>
  );
};

export default CallbackPage;

